<template functional>
    <div class="bto-sb-event-odds-nav">
        <div class="bto-sb-event-odds-nav-labels">
            <div class="bto-sb-event-odds-left">
                <div class="bto-sb-event-odds-cell bto-sb-event-timelabel">{{props.t('Public.Time')}}</div>
                <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{props.t('Public.Event')}}</div>
            </div>
            <div class="bto-sb-event-odds-right">
                <div class="bto-sb-event-odds-cell bto-sb-event-morelabel-odds">{{props.t('Mobile.more')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'MatchLabels',
    props: {
      t: {
        type: Function,
        default: (n) => n
      }
    }
  };
</script>
